import { Link } from 'react-router-dom';
import { Compass, Home, Plane, Phone } from 'lucide-react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { PHONE, SITE_NAME } from '../constants/site';

export default function NotFoundPage() {
  const tel = PHONE.replace(/[^\d+]/g, '');

  return (
    <>
      <Header />
      <section className="page-banner page-banner--compact not-found-banner">
        <div className="container">
          <p className="not-found__code" aria-hidden>
            404
          </p>
          <h1 className="not-found__title">Page not found</h1>
          <p className="not-found__subtitle">
            The page you are looking for does not exist or may have been moved. Let us help you get
            back on track with {SITE_NAME}.
          </p>
        </div>
      </section>

      <div className="container not-found">
        <div className="panel-premium not-found__panel">
          <div className="not-found__icon" aria-hidden>
            <Compass size={40} />
          </div>
          <h2>Where would you like to go?</h2>
          <p className="muted">Search flights, hotels, and more — or return to the homepage.</p>
          <div className="not-found__actions">
            <Link to="/flight" className="btn-gold">
              <Home size={18} aria-hidden />
              Back to home
            </Link>
            <Link to="/flight/search/flights" className="btn-outline not-found__btn-outline">
              <Plane size={18} aria-hidden />
              Search flights
            </Link>
            <a href={`tel:${tel}`} className="btn-outline not-found__btn-outline">
              <Phone size={18} aria-hidden />
              Call {PHONE}
            </a>
          </div>
          <p className="not-found__hint">
            Need help?{' '}
            <Link to="/flight/support">Contact our 24/7 support team</Link>.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}
